import { trans } from '@lingoda/i18n';
import { type SxProps, type Theme, Typography } from '@lingoda/ui';

interface OnboardingStepCounterProps {
    currentStep: number;
    totalSteps: number;
    sx?: SxProps<Theme>;
}

export const OnboardingStepCounter = (props: OnboardingStepCounterProps) => {
    return (
        <Typography
            variant="body3"
            sx={[
                (theme) => ({ color: theme.colors.text.progress, mb: 3 }),
                ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
            ]}
        >
            {trans(
                'onboarding-step-counter',
                { current: props.currentStep, total: props.totalSteps },
                'student-post-checkout',
            )}
        </Typography>
    );
};
